export const reliefs = {

    else: [
        {
            id: 0,
            name: "Bez ulgi",
            value: 0,
            description: "",
        },
    ],
    monthly: [
        {
            id: 0,
            name: "Bez ulgi",
            value: 0,
            description: "Bez ulgi",
        },
        {
            id: 1,
            name: "Niewidomy ns.",
            value: 0.93,
            description: "Osoba niewidoma niezdolna do samodzielnej egzystencji",
        },
        {
            id: 2,
            name: "Niewidomy",
            value: 0.37,
            description: "Osoby niewidome nie będące osobami niezdolnymi do samodzielnej egzystencji",
        },
        {
            id: 3,
            name: "Dziecko niep.",
            value: 0.78,
            description: "Dzieci i młodzież dotknięta inwalidztwem lub niepełnosprawna, przy przejazdach z miejsca zamieszkania lub miejsca pobytu do przedszkola, szkoły, ośrodka lub placówki o charakterze oświatowym albo szkoły wyższe (dziecko lub młodzież dotknięta inwalidztwem do 24 roku życia oraz studentów do ukończenia 26 roku życia)",
        },
        {
            id: 30,
            name: "Os.niesamodz.",
            value: 0.49,
            description: "Osoby niezdolne do samodzielnej egzystencji.",
        },
        {
            id: 4,
            name: "Student",
            value: 0.51,
            description: "Studenci do ukończenia 26 roku życia; osoby które ukończyły studia pierwszego stopnia do dnia 31 października roku, w którym ukończyły te studia.",
        },
        {
            id: 29,
            name: "Doktorant",
            value: 0.51,
            description: "Doktorant",
        },
        {
            id: 5,
            name: "Uczeń",
            value: 0.49,
            description: "Dzieci i młodzież w okresie rozpoczęcia odbywania obowiązkowego rocznego przygotowania przedszkolnego do ukończenia gimnazjum, szkoły ponadpodstawowej lub ponadgimnazjalnej – publicznej lub niepublicznej o uprawnieniach szkoły publicznej, nie dłużej niż do ukończenia 24 roku życia.",
        },
        {
            id: 6,
            name: "Nauczyciele",
            value: 0.33,
            description: "Nauczyciele przedszkoli publicznych lub niepublicznych; nauczyciele szkół podstawowych, gimnazjów i szkół ponadgimnazjalnych - publicznych lub niepublicznych o uprawnieniach szkół publicznych.",
        },
    ],
    normal: [
        {
            id: 0,
            name: "Bez ulgi",
            value: 0,
            description: "Bez ulgi",
        },
        {
            id: 7,
            name: "Dziecko do 4 lat",
            value: 1,
            description: "Dziecko w wieku do 4 lat pod warunkiem niekorzystania przez dziecko z oddzielnego miejsca do siedzenia",
        },
        {
            id: 8,
            name: "Dziecko do 4 lat – os. m.",
            value: 0.78,
            description: "Dziecko w wieku do 4 lat jeśli korzysta z osobnego miejsca do siedzenia",
        },
        {
            id: 9,
            name: "Dziecko powyżej 4 lat do rozpoczęcia przygotowania przedszkolnego",
            value: 0.37,
            description: "Dziecko w wieku powyżej 4 lat do rozpoczęcia odbywania obowiązkowego rocznego przygotowania przedszkolnego",
        },
        {
            id: 10,
            name: "Dziecko niep.",
            value: 0.78,
            description: "Dzieci i młodzież dotknięta inwalidztwem lub niepełnosprawna, przy przejazdach z miejsca zamieszkania lub miejsca pobytu do przedszkola, szkoły, ośrodka lub placówki o charakterze oświatowym albo szkoły wyższe (dziecko lub młodzież dotknięta inwalidztwem do 24 roku życia oraz studentów do ukończenia 26 roku życia)",
        },
        {
            id: 11,
            name: "Opiekun Dz.niep",
            value: 0.37,
            description: "Jedno z rodziców lub opiekun towarzyszący dzieciom i młodzieży dotkniętym inwalidztwem lub niepełnosprawnym przy przejazdach do przedszkola, szkoły, ośrodka lub placówki o charakterze oświatowym albo szkoły wyższe.",
        },
        {
            id: 12,
            name: "Niewidomy ns.",
            value: 0.93,
            description: "Osoby niewidome będące osobami niezdolnymi do samodzielnej egzystencji.",
        },
        {
            id: 13,
            name: "Niewidomy",
            value: 0.37,
            description: "Osoby niewidome nie będące osobami niezdolnymi do samodzielnej egzystencji.",
        },
        {
            id: 14,
            name: "Niewid.of.dz.woj",
            value: 0.78,
            description: "Cywilne niewidome ofiary działań wojennych uznane za osoby niezdolne do samodzielnej egzystencji.",
        },
        {
            id: 15,
            name: "Przewod.niewid.",
            value: 0.95,
            description: "Przewodnik lub opiekun towarzyszący w podróży osobie niewidomej albo niezdolnej do samodzielnej egzystencji.",
        },
        {
            id: 16,
            name: "Os.niesamodz.",
            value: 0.49,
            description: "Osoby niezdolne do samodzielnej egzystencji.",
        },
        {
            id: 17,
            name: "Op.os.niesamodz.",
            value: 0.95,
            description: "Przewodnik lub opiekun towarzyszący w podróży osobie niezdolnej do samodzielnej egzystencj.",
        },
        {
            id: 18,
            name: "Inw.woj.I Gr.",
            value: 0.78,
            description: "Inwalidzi wojenni (wojskowi) zaliczeni do I grupy inwalidów lub uznani za niezdolnych do samodzielnej egzystencji, Kombatant lub osoby represjonowane będące inwalidami wojennymi, zaliczeni do I grupy inwalidów oraz członkom rodzin osób represjonowanych pobierających w chwili śmierci rentę z tytułu inwalidztwa.",
        },
        {
            id: 19,
            name: "Op.inw.woj.I Gr.",
            value: 0.95,
            description: "Przewodnik lub opiekun towarzyszący w podróży inwalidzie wojennemu zaliczonemu do I grupy inwalidów.",
        },
        {
            id: 20,
            name: "Inwalida Woj.",
            value: 0.37,
            description: "Inwalidzi wojenni i wojskowi zaliczeni do innej grupy inwalidów niż I, Kombatant będący inwalidą wojennym (wojskowym), osoby represjonowane zaliczone do jednej z grup inwalidztwa pozostającego w związku z represjonowaniem, członkowie rodzin pozostałych po kombatantach oraz członkowie rodzin osób represjonowanych pobierających w chwili śmierci rentę z tytułu inwalidztwa.",
        },
        {
            id: 21,
            name: "Weteran inwalida",
            value: 0.37,
            description: "Weteran poszkodowany pobierający rentę inwalidzką z tytułu urazów lub chorób powstałych w związku z udziałem w działaniach poza granicami państwa.",
        },
        {
            id: 22,
            name: "Kombatant",
            value: 0.51,
            description: "Kombatantom i innym osobom uprawnionym – emerytom, rencistom i inwalidom oraz osobom pobierającym uposażenie w stanie spoczynku lub uposażenie rodzinne, wdowom, wdowcom – emerytom i rencistom oraz osobom pobierającym uposażenie w stanie spoczynku lub uposażenie rodzinne pozostałym po kombatantach i innych osobach uprawnionych.",
        },
        {
            id: 28,
            name: "Osoba Represjonowana",
            value: 0.51,
            description: "Osoba Represjonowana.",
        },
        {
            id: 23,
            name: "Straż Gran.-służ.",
            value: 0.78,
            description: "Umundurowani funkcjonariusze Straży Granicznej w czasie wykonywania czynności służbowych związanych z ochroną granicy państwowej, a także w czasie konwojowania osób zatrzymanych, służby patrolowej oraz wykonywania czynności związanych z kontrolą ruchu granicznego.",
        },
        {
            id: 24,
            name: "Celnik-służ.",
            value: 0.78,
            description: "Funkcjonariusze celni w czasie wykonywania czynności służbowych kontroli celnej w ruchu granicznym.",
        },
        {
            id: 25,
            name: "Policjant-służ.",
            value: 0.78,
            description: "Umundurowani funkcjonariusze Policji w czasie konwojowania osób zatrzymanych lub chronionego mienia, przewożenia poczty specjalnej, służby patrolowej oraz udzielania pomocy lub asystowania przy czynnościach organów egzekucyjnych.",
        },
        {
            id: 26,
            name: "Żołnierz ŻW-służ.",
            value: 0.78,
            description: "Żołnierze Żandarmerii Wojskowej oraz wojskowych organów porządkowych wykonujący czynności służbowe w środkach transportu zbiorowego.",
        },
        {
            id: 27,
            name: "Żołnierz Sł. Zasad.",
            value: 0.78,
            description: "Żołnierze odbywający niezawodową służbę wojskową, z wyjątkiem służby okresowej i nadterminowej, oraz dla osób spełniające obowiązek tej służby formach równorzędnych.",
        },
    ]
};